// Common image file extensions
export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'svg', 'webp', 'gif'];

// Check if Content-Type header indicates an image
export const isImageContentType = (contentType: string | null): boolean => {
  if (!contentType) return false;
  return contentType.toLowerCase().startsWith('image/');
};

export const normalizeIconName = (name: string): string => {
  // Create a stable, canonical slug used across storage and DB keys
  // 1) Strip file extension
  // 2) Lowercase
  // 3) Replace any non-alphanumeric with hyphens
  // 4) Collapse duplicate hyphens and trim
  const base = name
    .replace(/\.(png|jpg|jpeg|svg|webp|gif)$/i, '')
    .toLowerCase().trim();
  return base
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const getIconFileExtension = (filename: string): string => {
  const ext = filename.split('.').pop()?.toLowerCase();
  return ext || 'png';
};

export const buildIconUrl = (baseName: string, extension: string = 'png'): string => {
  return `https://dvawogvuaomipakwlvst.supabase.co/storage/v1/object/public/listing-images/icons/${baseName}.${extension}`;
};

export const buildIconUrlForCategory = (
  category: string,
  baseName: string,
  extension: string = 'png'
): string => {
  const subfolder = category === 'service_type' ? 'services/' : '';
  return `https://dvawogvuaomipakwlvst.supabase.co/storage/v1/object/public/listing-images/icons/${subfolder}${baseName}.${extension}`;
};

/**
 * Add cache-busting query parameter to Supabase URLs
 */
export const addCacheBuster = (url: string): string => {
  if (!url || !url.includes('supabase.co')) return url;
  return url.includes('?') ? url : `${url}?v=${Date.now()}`;
};